module.exports = __webpack_public_path__ + "media/10SecCountdownTimer.cae8990e.mp3";